import {
    GET_META_SOCIAL_MEDIA_STARTED,
    GET_META_SOCIAL_MEDIA_SUCCESS,
    GET_META_SOCIAL_MEDIA_FAILURE,
    LINK_FACEBOOK_PAGE_STARTED,
    LINK_FACEBOOK_PAGE_SUCCESS,
    LINK_FACEBOOK_PAGE_FAILURE,
    LOG_OUT_META_STARTED,
    LOG_OUT_META_SUCCESS,
    LOG_OUT_META_FAILURE,
    GET_FACEBOOK_PAGES_STARTED,
    GET_FACEBOOK_PAGES_SUCCESS,
    GET_FACEBOOK_PAGES_FAILURE,
    GET_META_POSTS_STARTED,
    GET_META_POSTS_SUCCESS,
    GET_META_POSTS_FAILURE,
    GET_SOCIAL_POSTS_STARTED,
    GET_SOCIAL_POSTS_SUCCESS,
    GET_SOCIAL_POSTS_FAILURE,
    CREATE_SOCIAL_POST_STARTED,
    CREATE_SOCIAL_POST_SUCCESS,
    CREATE_SOCIAL_POST_FAILURE,
    ADD_COMMENT_SUCCESS,
    ADD_COMMENT_FAILURE,
    REPLY_COMMENT_SUCCESS,
    REPLY_COMMENT_FAILURE,
    REMOVE_ERROR_MESSAGE,
    ADD_COMMENT_STARTED,
    REPLY_COMMENT_STARTED
} from "../../constants/meta/meta";

const initialState = {
    metaSocialMedia: null,
    facebookPages: [],
    metaPosts: [],
    socialPosts: { facebook: [], instagram: [] },
    socialPostsNextCursor: { facebook: null, instagram: null },
    loading: false,
    loadingAddPost: false,
    loadingSocialPosts: false,
    loadingComments: false,
    error: null,
    message: null,
};

const updatePost = (socialPosts, platform, postId, updater) => ({
    ...socialPosts,
    [platform]: socialPosts[platform].map(post =>
        post.id === postId ? updater(post) : post
    )
});

export default function meta(state = initialState, action) {
    switch (action.type) {
        case GET_META_SOCIAL_MEDIA_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case GET_META_SOCIAL_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                metaSocialMedia: action.payload.data
            };
        case GET_META_SOCIAL_MEDIA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case LINK_FACEBOOK_PAGE_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case LINK_FACEBOOK_PAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: action.payload.message,
                metaSocialMedia: action.payload.data
            };
        case LINK_FACEBOOK_PAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        case LOG_OUT_META_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case LOG_OUT_META_SUCCESS:
            return {
                ...state,
                facebookPages: [],
                metaSocialMedia: action.payload.data,
                loading: false,
                error: null,
                message: null
            };
        case LOG_OUT_META_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        case GET_FACEBOOK_PAGES_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case GET_FACEBOOK_PAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                facebookPages: action.payload.facebookPages
            };
        case GET_FACEBOOK_PAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case GET_META_POSTS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case GET_META_POSTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                metaPosts: action.payload.metaPosts
            };
        case GET_META_POSTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case CREATE_SOCIAL_POST_STARTED:
            return {
                ...state,
                loadingAddPost: true,
                error: null,
                message: null
            };
        case CREATE_SOCIAL_POST_SUCCESS:
            return {
                ...state,
                loadingAddPost: false,
                error: null,
                message: 'Posted successfully!'
            };
        case CREATE_SOCIAL_POST_FAILURE:
            return {
                ...state,
                loadingAddPost: false,
                error: action.payload.error
            };

        case GET_SOCIAL_POSTS_STARTED:
            return {
                ...state,
                loadingSocialPosts: true,
                error: null,
                message: null
            };
        case GET_SOCIAL_POSTS_SUCCESS:
            return {
                ...state,
                loadingSocialPosts: false,
                error: null,
                socialPosts: {
                    ...state.socialPosts,
                    [action.payload.platform]: action.payload.reset
                        ? action.payload.posts
                        : [...state.socialPosts[action.payload.platform], ...action.payload.posts]
                },
                socialPostsNextCursor: {
                    ...state.socialPostsNextCursor,
                    [action.payload.platform]: action.payload.next
                }
            };
        case GET_SOCIAL_POSTS_FAILURE:
            return {
                ...state,
                loadingSocialPosts: false,
                error: action.payload.error
            };

        case ADD_COMMENT_STARTED:
            return {
                ...state,
                loadingComments: true,
                error: null,
                message: null
            };    
        case ADD_COMMENT_SUCCESS:
            return {
                ...state,
                loadingComments: false,
                socialPosts: updatePost(state.socialPosts, action.payload.platform, action.payload.postId, post => ({
                    ...post,
                    commentCount: (post.commentCount || 0) + 1,
                    comments: [...(post.comments || []), action.payload.comment]
                }))
            };
        case ADD_COMMENT_FAILURE:
            return {
                ...state,
                loadingComments: false,
                error: action.payload.error
            };
        
        case REPLY_COMMENT_STARTED:
            return {
                ...state,
                loadingComments: true,
                error: null,
                message: null
            };

        case REPLY_COMMENT_SUCCESS:
            return {
                ...state,
                loadingComments: false,
                socialPosts: updatePost(state.socialPosts, action.payload.platform, action.payload.postId, post => ({
                    ...post,
                    comments: post.comments.map(comment =>
                        comment.id === action.payload.commentId
                            ? { ...comment, replies: [...(comment.replies || []), action.payload.reply] }
                            : comment
                    )
                }))
            };
        case REPLY_COMMENT_FAILURE:
            return {
                ...state,
                loadingComments: false,
                error: action.payload.error
            };

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        default:
            return {
                ...state,
            };
    }
}